/* eslint max-classes-per-file: 0 */

import { MunMeh as Data, MunMehCollection as Collection } from '@/typings/api/MunMeh'
import { LkMunMehApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class LkMunMehTransformerParams extends TransformerParams {
  // ..
}

export class LkMunMehAdapter extends Adapter<Api> {
    public readonly api = new Api();

    public readonly transformerParams = new LkMunMehTransformerParams();
}
